import React from 'react';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import dollarsToCents from 'dollars-to-cents';

interface IInputGroupBlockSchema {
  options?: any;
  schema?: any;
  uiSchema?: any;
  id?: any;
  label?: any;
  value?: any;
  formData?: any;
  onChange?: any;
  onBlur?: any;
  onFocus?: any;
  required?: any;
  disabled?: any;
  readonly?: any;
  formContext?: any;
  autofocus?: any;
  registry?: any;
  placeholder?: any;
  rawErrors?: any;
}
export default class InputGroupBlockSchema extends React.Component<
IInputGroupBlockSchema
> {
  handleChange = (e) => {
    if (this.props.schema.inputType === 'select') {
      // console.log(e);

      this.props.onChange(e);
    } else if (this.props.schema.inputType === 'boolean') {
      const newValue = !this.props.formData || false;
      this.props.onChange(newValue);
    } else if (this.props.schema.inputType === 'currency') {
      // console.log(e);
      const { formattedValue } = e;

      this.props.onChange(formattedValue);
    } else if (this.props.schema.inputType === 'datetime') {
      // console.log(e);
      const formattedValue = _.map(e, (f) => f.toString());
      this.props.onChange(formattedValue);
    } else if (this.props.schema.inputType === 'phone') {
      // console.log(e);
      // const formattedValue = _.map(e, (f) => f.toString());
      this.props.onChange(e);
    } else {
      // console.log(e.target.value);
      if (e.target.value === '') {
        this.props.onChange(this.props.uiSchema['ui:emptyValue'] || undefined);
      } else {
        this.props.onChange(e.target.value);
      }
    }
  };

  render(): React.ReactNode {
    const errors = {
      [this.props.name]: this.props.rawErrors,
    };
    let inputType = this.props.schema.inputType || this.props.schema.type;
    if (inputType === 'string') {
      inputType = 'text';
    }
    if (inputType === 'number') {
      inputType = 'tel';
    }
    return (
      <InputGroupBlock
        {...this.props}
        labelText={this.props.schema.title}
        value={this.props.formData}
        type={inputType}
        options={this.props.schema.options}
        clearable={this.props.schema.clearable}
        createable={this.props.schema.createable}
        enableTime={this.props.schema.enableTime}
        mode={this.props.schema.mode}
        onChange={this.handleChange}
        errors={errors}
      />
    );
  }
}
